import { notification, Space, Table } from "antd";
import { ContentWrapper } from "../../common/components/pageContent/contentWrapper";
import { LayoutWrapper } from "../../common/components/pageContent/layoutWrapper";
import { hasPermission, RoleChecker } from "../../utils/roleChecker";
import { roleTypes } from "../../users/userType";
import { useTranslation } from "react-i18next";
import { useSelectedOrgId } from "../../organizations/orgState";
import { useLoggedInUser } from "../../auth/authState";
import { Button } from "../../common/components/ant/button";
import { DownloadOutlined } from "@ant-design/icons";
import axios from "axios";
import OrgTreeSelect from "../../common/components/pageContent/orgTreeSelect";
import download from "js-file-download";

interface ReportRow {
  reportURI: string;
  reportDisplayName: string;
  reportFallbackName: string;
  key: string;
}

const restURL = process.env.REACT_APP_API_ENDPOINT;

const Reports = () => {
  const selectedOrgId = useSelectedOrgId();
  const loggedInUser = useLoggedInUser();
  const { t } = useTranslation();

  const getReport = (URI: string, fileName: string) => {
    axios
      .get(`${restURL}${URI}`, { responseType: "blob" })
      .then((response) => {
        const fileName = response.headers["content-disposition"]
          ?.split("filename=")[1]
          .trim();
        download(response.data, fileName);
        notification.open({ message: "File downloaded successfully" });
      })
      .catch(() =>
        notification.open({
          message: "Something went wrong while downloading the file",
        })
      );
  };

  const dataSource: ReportRow[] = [
    {
      key: "1",
      reportURI: `/reports/organizations/${selectedOrgId}`,
      reportDisplayName: t("reports.organizationHierarchy"),
      reportFallbackName: "organization-hierarchy.txt",
    },
    {
      key: "2",
      reportURI: `/reports/members/?orgId=${selectedOrgId}`,
      reportDisplayName: t("reports.membersReport"),
      reportFallbackName: "users-report.xlsx",
    },
    {
      key: "3",
      reportURI: `/reports/org-capabilities/${selectedOrgId}`,
      reportDisplayName: t("reports.organizationalCapabilitesReport"),
      reportFallbackName: "org-capabilities-report.xlsx",
    },
    {
      key: "4",
      reportURI: `/reports/events/${selectedOrgId}`,
      reportDisplayName: t("reports.eventsReport"),
      reportFallbackName: "events-report.xlsx",
    },
  ];

  const columns = [
    {
      title: t("reports.name"),
      dataIndex: "reportDisplayName",
    },
    hasPermission([roleTypes.ADMIN], loggedInUser, selectedOrgId)
      ? {
          key: "action",
          render: (record: ReportRow) => (
            <RoleChecker roles={[roleTypes.ADMIN]}>
              <Space size="middle">
                <Button
                  className="create"
                  onClick={() =>
                    getReport(record.reportURI, record.reportFallbackName)
                  }
                  icon={<DownloadOutlined />}
                />
              </Space>
            </RoleChecker>
          ),
        }
      : {},
  ];

  return (
    <LayoutWrapper>
      <div className={`page-title-container`}>
        <OrgTreeSelect />
      </div>
      <ContentWrapper>
        <div className="table-container">
          <Table dataSource={dataSource} columns={columns} pagination={false} />
        </div>
      </ContentWrapper>
    </LayoutWrapper>
  );
};

export default Reports;
